import React from 'react';
import liscioLogoPng from 'images/liscioLogo.png';

export interface LoginPageLayoutProps {
  children?: React.ReactNode;
  showLogo?: boolean;
}

export const LoginPageLayout = ({
  children,
  showLogo,
}: LoginPageLayoutProps) => (
  <div className="crPage">
    <div className="crPage--inner">
      <div className="crPage--innerForm">
        <div className="crPage--innerForm--sec">
          <div className="crPage--head text-center">
            {showLogo && (
              <img
                src={liscioLogoPng}
                className="homeLogo"
                alt="Lisico"
                data-testid="home_logo"
              />
            )}
            {children}
          </div>
        </div>
        <div className="crPage--innerForm--footer">
          <div className="crPaeg--links">
            <a
              className="px-0"
              href="https://liscio.me/privacy-policy/"
              target="_blank"
              rel="noreferrer"
            >
              Privacy Policy
            </a>
            <a
              className="px-0"
              href="https://liscio.me/contact/"
              target="_blank"
              rel="noreferrer"
            >
              Contact Us
            </a>
          </div>
          <div className="crPage--copyright">
            <p>&copy; {new Date().getFullYear()} Lisco. All rights reserved.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default LoginPageLayout;
